var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.75c-1.22 0-2.25-1.03-2.25-2.25s1.03-2.25 2.25-2.25 2.25 1.03 2.25 2.25-1.03 2.25-2.25 2.25zm-15 0c-1.22 0-2.25-1.03-2.25-2.25s1.03-2.25 2.25-2.25 2.25 1.03 2.25 2.25-1.03 2.25-2.25 2.25zm-1.5-5h18v-1.5H3v1.5zm18.15-8.74a2.578 2.578 0 00-2.42-1.76H5.28c-1.14 0-2.07.68-2.42 1.76l-2.57 7.5L.25 21c0 1.16.59 1.75 1.75 1.75h2c1.15 0 1.71-.56 1.71-1.68v-.32h12.54V21c0 1.16.59 1.75 1.75 1.75h2c1.16 0 1.75-.59 1.75-1.75V10.75l-2.6-7.74z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.75c-1.22 0-2.25-1.03-2.25-2.25s1.03-2.25 2.25-2.25 2.25 1.03 2.25 2.25-1.03 2.25-2.25 2.25zm-15 0c-1.22 0-2.25-1.03-2.25-2.25s1.03-2.25 2.25-2.25 2.25 1.03 2.25 2.25-1.03 2.25-2.25 2.25zm-1.5-5h18v-1.5H3v1.5zm18.15-8.74a2.578 2.578 0 00-2.42-1.76H5.28c-1.14 0-2.07.68-2.42 1.76l-2.57 7.5L.25 21c0 1.16.59 1.75 1.75 1.75h2c1.15 0 1.71-.56 1.71-1.68v-.32h12.54V21c0 1.16.59 1.75 1.75 1.75h2c1.16 0 1.75-.59 1.75-1.75V10.75l-2.6-7.74z",
    fill: "#6e6e6e",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e90a0a",
    d: "M0 0h6.27v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26221e",
    d: "M6.27 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8600",
    d: "M6.98 0h6.46v24H6.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ae0000",
    d: "M13.44 0h4.22v24h-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065b1",
    d: "M17.66 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008520",
    d: "M18.11 0H24v24h-5.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.7dcc7e5ce6f215248bd2a586e51946b8.svg";
export { ForwardRef as ReactComponent };